import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/empty-course-forum.svg'
import _imports_1 from '@/assets/images/not-found-course-forum.svg'


const _hoisted_1 = { class: "w-full h-full mb-16" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  alt: "empty courses",
  class: "w-[657px] mx-auto flex mt-32"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "p-input-icon-right w-[41vw] w-max-[657px]" }
const _hoisted_6 = {
  key: 0,
  class: "pi pi-search"
}
const _hoisted_7 = { class: "my-6 text-[#050505]" }
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col items-center justify-center"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "not found course",
  class: "w-[657px] my-auto flex mt-32"
}, null, -1)
const _hoisted_10 = {
  key: 1,
  class: "flex flex-col gap-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ForumCard = _resolveComponent("ForumCard")!
  const _component_Paginator = _resolveComponent("Paginator")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(_component_Loader, { loader: _ctx.isLoading }, null, 8, ["loader"]),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          (!_ctx.query.name && _ctx.totalForums == 0)
            ? (_openBlock(), _createElementBlock("img", _hoisted_3))
            : (_openBlock(), _createElementBlock("section", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, [
                  _createVNode(_component_InputText, {
                    type: "text",
                    modelValue: _ctx.inputCourseName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputCourseName) = $event)),
                    placeholder: _ctx.$t('course.search'),
                    class: "p-inputtext-sm",
                    onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.filterCourseByName()), ["enter"]))
                  }, null, 8, ["modelValue", "placeholder"]),
                  (!_ctx.inputCourseName)
                    ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                    : (_openBlock(), _createElementBlock("i", {
                        key: 1,
                        class: "cursor-pointer pi pi-times",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearFilter && _ctx.clearFilter(...args)))
                      }))
                ]),
                _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.formatSearchText()), 1),
                (_ctx.query.name && _ctx.totalForums == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("button", {
                        class: "flex justify-center mt-6 items-center btn-outline rounded px-2 py-[6px]",
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearFilter && _ctx.clearFilter(...args)))
                      }, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Limpar pesquisa",
                en: "Clear search",
              })), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course) => {
                        return (_openBlock(), _createBlock(_component_ForumCard, {
                          course: course,
                          key: course.id
                        }, null, 8, ["course"]))
                      }), 128)),
                      (_ctx.totalForums > _ctx.numberofForumsPerPage)
                        ? (_openBlock(), _createBlock(_component_Paginator, {
                            key: 0,
                            totalRecords: _ctx.totalForums,
                            rows: _ctx.numberofForumsPerPage,
                            value: _ctx.courses,
                            first: _ctx.getFirstItemIndexActualPage(),
                            onPage: _ctx.onPaginate,
                            pageLinkSize: 3,
                            class: "mb-16 md:w-full w-fit md:flex md:right-0 md:justify-end custom-paginator-forum"
                          }, null, 8, ["totalRecords", "rows", "value", "first", "onPage"]))
                        : _createCommentVNode("", true)
                    ]))
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}